import React, { ReactElement } from 'react';
import {
  getClassNameFactory,
  Heading,
  Rank,
  Sizes,
  TextBoldness,
  Typography,
  VerticalSpacing,
  VerticalSpacingSizes,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import {
  ICountry,
  ILanguage,
  INumber,
  IPhoneSupport,
  IPhoneSuppInfo,
} from '../TalkWithUsModal/TalkWithUsModal.types';
import './PhoneSupport.css';
import { constant } from './constant';
import { v4 as uuid } from 'uuid';

const PhoneSupport: React.FC<IPhoneSupport> = ({
  phoneSupportInfo,
  phoneSupportInfoInBrackets,
  countries,
}): ReactElement => {
  const getClassName = getClassNameFactory(PhoneSupport.displayName);
  return (
    <div className={getClassName()}>
      <VerticalSpacing size={VerticalSpacingSizes.M}>
        <Heading
          type={types.XtraSmall}
          boldType={boldTypes.black}
          rank={Rank.Second}
        >
          {constant.phoneSupportHeading}
        </Heading>
        <Typography type={Sizes.XXTRASMALL} tag={TypographyTags.P}>
          {phoneSupportInfo?.map((info: IPhoneSuppInfo) => {
            return (
              <p key={uuid()}>
                <strong>{info.boldText}: </strong>
                {info.text}
              </p>
            );
          })}
        </Typography>
        <Typography
          type={Sizes.XXXTRASMALL}
          tag={TypographyTags.P}
          className={getClassName({ descendantName: 'supportText' })}
        >
          {phoneSupportInfoInBrackets && ` (${phoneSupportInfoInBrackets})`}
        </Typography>
      </VerticalSpacing>
      <ul>
        {countries?.map((country: ICountry) => {
          return (
            <li
              className={getClassName({ descendantName: 'countryList' })}
              key={uuid()}
            >
              <Typography
                type={Sizes.XTRASMALL}
                tag={TypographyTags.P}
                boldness={TextBoldness.Black}
              >
                {country.countryName}
              </Typography>
              <ul>
                {country.phoneList.map((number: INumber) => {
                  return (
                    <li key={uuid()}>
                      <Typography
                        type={Sizes.XXTRASMALL}
                        tag={TypographyTags.P}
                        key={number.number}
                      >
                        <strong>{number.number}</strong>
                        {number.infoInBrackets && ` (${number.infoInBrackets})`}
                      </Typography>
                    </li>
                  );
                })}

                {country.languageList.map((language: ILanguage) => {
                  return (
                    <li key={uuid()}>
                      <Typography
                        type={Sizes.XXTRASMALL}
                        tag={TypographyTags.P}
                        key={language.language}
                      >
                        <strong>
                          {language.language}
                          {language.info && ':'}
                        </strong>{' '}
                        {language.info}
                      </Typography>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

PhoneSupport.displayName = 'PhoneSupport';
export default PhoneSupport;
